"use client";

/**
 * 상품 목록 컴포넌트 — 그리드 레이아웃
 *
 * 전환 애니메이션은 ShoppingContent의 isFetching opacity로 처리.
 * 이 컴포넌트는 순수 레이아웃만 담당.
 */
import type { ProductListItem } from "@/shared/api/services/productService";

import { ProductCard } from "@/features/shopping/components/ProductCard";

interface ProductListProps {
  products: ProductListItem[];
}

export function ProductList({ products }: ProductListProps) {
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      {products.map((product, i) => (
        <ProductCard key={product.id} product={product} priority={i < 8} />
      ))}
    </div>
  );
}
